import httpService from "../httpService";

export default {
  findAllByHcCaseMasterId(hcCaseMasterId) {
    let params = {hcCaseMasterId: hcCaseMasterId};
    return httpService.get("/hcCaseFlightRouteUserView/findAllByHcCaseMasterId", {params: params});
  },
};



// WEBPACK FOOTER //
// ./src/services/maybay/hcCaseFlightRouteUserViewService.js